<template>
  <div>
    <page-title style="font-size: 14px;" :override_data="{ resource_type: payload.resource_type, resource_id: payload.resource_id, company_id: getCompanyId }"></page-title>
    <div v-if="form">
      <div class="is-flex is-align-items-flex-end is-justify-content-space-between">
        <div>
          <p><b>Designator</b></p>
          <select dir="rtl" :class="{ is_edit: !payload.is_create }" v-model="form.data.text.fields.designator.value">
            <option v-for="text in texts" :key="text">{{text}}</option>
          </select>
        </div>
      </div>
      <div>
        <p><b>Content</b></p>
        <div v-if="isCheckBox">
          <Checkbox v-model="form.data.text.fields.content.value" :checked="form.data.text.fields.content.value == 'true'">
            מאושר
          </Checkbox>
        </div>
        <div v-else>
          <textarea v-model="form.data.text.fields.content.value" placeholder="Content" class="full_width" rows="18"></textarea>
        </div>
      </div>
    </div>
    <div class="modal_footer is-justify-content-space-between">
      <a
        @click="preSubmit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
      <div class="my-5">
        <checkbox v-model="eleven_months_alert" :checked="eleven_months_alert">11_months_alert</checkbox>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import TextsHelper from '@/custom/classes/texts_helper.js'
import PageTitle from '@/components/PageTitle'
import Checkbox from '@/components/Checkbox'
export default {
  name: 'company-texts-form',
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      form: undefined,
      gender: '',
      texts_helper: new TextsHelper(),
      eleven_months_alert: false,
      applicant_texts: [
        'license_number',
        'international_license_number',
        'additional_activities',
        'highschool',
        'highschool_year_start',
        'highschool_year_end',
        'military_year_start',
        'military_year_end',
        'referral_text',
        'work_experience_achievements',
        'dream_job',
        'recommendations',
        'about_me',
        'internal_abstract',
        'lite_abstract',
        'story',
        'spoken_feedback',
        'feedback',
        'outsource_cv_path',
        'job_description',
        'rejected_files',
        'approved_files'
      ],
      company_texts: [
        'about_the_company',
        'contact_email',
        'personal_traits_demands',
        'why_work_with_us',
        'company_expertise',
        'public_hidden_name',
        'partners',
        'internal_abstract',
        'position_serial_from_external',
        'abstract',
        'story',
        'salary',
        'referral_text',
        'internal_notes',
        'community_contributions',
        'work_entails',
        'notable_clients',
        'intern_work_type',
        'intern_offered_benefits',
        'intern_unique_office_work',
        'working_hours',
        'prompt',
        'salary_expectations',
        'finance_email',
        'finance_contact',
        'finance_percentage',
        'is_send_one_file',
        'disable_automatic_company_response',
        'billing_percentage',
        'billing_days'
      ],
      checkbox: [
        'is_send_one_file',
        'disable_automatic_company_response'
      ]
    }
  },
  created () {
    this.init()
  },
  computed: {
    isCheckBox () {
      return this.checkbox.includes(this.form.data.text.fields.designator.value)
    },
    texts () {
      return this.payload.resource_type == 'Applicant' ? this.applicant_texts : this.company_texts
    },
    getCompanyId () {
      if (this.payload.data == undefined) {
        return this.payload.company_id
      }
      if (this.payload.data.company_id == undefined) {
        return this.payload.company_id
      }
      return this.payload.data.company_id
    }
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        this.setForm({
          id: '',
          designator: this.payload.init_designator || '',
          content: this.payload.init_content
        })
        return
      }
      this.$network_utils.getResourceTexts({ current_type: this.payload.resource_type, current_resource_id: this.payload.resource_id }).then(response => {
        this.setForm(this.texts_helper.getTextByDesignator(response, this.payload.data.designator))
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        text: {
          fields: {
            designator: {
              value: form_data.designator,
              has_error: false,
              validations: []
            },
            content: {
              value: form_data.content,
              has_error: false,
              validations: []
            },
            current_type: {
              value: this.payload.resource_type,
              has_error: false,
              validations: []
            },
            current_resource_id: {
              value: this.payload.resource_id,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/resource_texts/' + form_data.id,
            headers: 'shared_headers'
          },
          is_used: true
        }
      })
    },
    preSubmit () { // TODO: by removing the abstract from text table is this logic still needed here ?
      if (this.form.data.text.fields.designator.value == 'abstract' && this.eleven_months_alert) {
        this.$network_utils.postAlert({
          designator: 'missions',
          content: 'ליצור קשר עוד 11 חודשים',
          status: 'active',
          priority: 90,
          resource_type: 'Applicant',
          resource_id: this.payload.resource_id,
          timing: this.$moment().add(11, 'months')
        })
      }
      this.submit()
    },
    submit () {
      let bold_content = this.texts_helper.getBoldContent(this.form.data.text.fields.content.value.toString(), this.form.data.text.fields.designator.value)
      if (bold_content == 'problem') {
        return
      }
      this.form.data.text.fields.content.value = bold_content
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.sendContentChangedStat()
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    sendContentChangedStat () {
      if (this.payload.is_create) {
        return
      }
      let old_content = this.payload.data.content
      let new_content = this.form.data.text.fields.content.value
      if (old_content == new_content) {
        return
      }
      let stat_content = this.payload.data.designator + ' Changed:<br><b>Old Content was:</b> ' + old_content + '<br><b>New Content is:</b> ' + new_content
      this.$network_utils
        .postStat({
          title: 'new internal note',
          designator: 'internal_notes',
          content: stat_content,
          status: 'done',
          owner: this.$utils.getOwner().name,
          priority: 7,
          resource_id: this.payload.data.resource_id,
          resource_type: this.payload.data.resource_type
        })
    },
    ...mapMutations('modals', ['remove', 'create', 'removeModalById'])
  },
  components: {
    PageTitle,
    Checkbox
  }
}
</script>
<style scoped>
  .is_edit{
    pointer-events: none;
    opacity: 0.3;
  }
</style>
